import { render, staticRenderFns } from "./AuthUserLabel.vue?vue&type=template&id=2c30a6f1&scoped=true&"
import script from "./AuthUserLabel.vue?vue&type=script&lang=js&"
export * from "./AuthUserLabel.vue?vue&type=script&lang=js&"
import style0 from "./AuthUserLabel.vue?vue&type=style&index=0&id=2c30a6f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30a6f1",
  null
  
)

export default component.exports